import { useState, useRef } from 'react';
import { Point } from '../../../../context/context';

export type TransitTimeCache = Map<string, number>;

export interface TransitScanState {
    loading: boolean;
    progress: number;
    isModalOpen: boolean;
    point: Point | null;
    cache: TransitTimeCache;
}

export interface TransitScanActions {
    setLoading: (loading: boolean) => void;
    setProgress: (progress: number) => void;
    setIsModalOpen: (open: boolean) => void;
    setPoint: (point: Point | null) => void;
    resetState: () => void;
}

export const useTransitScan = (): [TransitScanState, TransitScanActions] => {
    const [loading, setLoading] = useState(false);
    const [progress, setProgress] = useState(0);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [point, setPoint] = useState<Point | null>(null);
    const cache = useRef<TransitTimeCache>(new Map()).current;

    const resetState = () => {
        setLoading(false);
        setProgress(0);
        setIsModalOpen(false);
        setPoint(null);
    };

    return [
        { loading, progress, isModalOpen, point, cache },
        { setLoading, setProgress, setIsModalOpen, setPoint, resetState }
    ];
}; 